import { useTranslation } from 'react-i18next';

const Ofertas = ({ lang }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";
    // Datos de las ofertas
    const offers = [
        {
            href: "/" + preidioma + t("last-minute"),
            title: t("OFERTA"),
            location: t("CROACIA"),
            type: t("PREMIUM"),
            price: t("Desde").toUpperCase() + " 900€",
            shapeClass: 'u-shape-1',
            textClass: 'u-text-1',
            btnClass: 'u-btn-1',
            layoutClass: 'u-container-layout-1'
        },
        {
            href: "/" + preidioma + t("last-minute"),
            title: t("OFERTA"),
            location: t("CROACIA"),
            type: t("TRADICIONAL"),
            price: t("Desde").toUpperCase() + " 650€",
            shapeClass: 'u-shape-2',
            textClass: 'u-text-2',
            btnClass: 'u-btn-2',
            layoutClass: 'u-container-layout-2'
        },
        {
            href: "/" + preidioma + t("last-minute"),
            title: t("OFERTA"),
            location: t("TURQUÍA"),
            type: t("PREMIUM"),
            price: t("Desde").toUpperCase() + " 900€",
            shapeClass: 'u-shape-3',
            textClass: 'u-text-3',
            btnClass: 'u-btn-3',
            layoutClass: 'u-container-layout-3'
        },
        {
            href: "/" + preidioma + t("last-minute"),
            title: t("OFERTA"),
            location: t("TURQUÍA"),
            type: t("TRADICIONAL"),
            price: t("Desde").toUpperCase() + " 740€",
            shapeClass: 'u-shape-4',
            textClass: 'u-text-4',
            btnClass: 'u-btn-4',
            layoutClass: 'u-container-layout-4'
        }
    ];

    return (
        <>
            <style>
                {`
                    .boat-offers-container {
                        display: flex!important;
                        justify-content: center;
                    }
                    /* Estilos para el grid responsivo */
                    .responsive-grid {
                        display: flex;
                        justify-content: center;
                    }
                    @media (max-width: 768px) {
                        .responsive-grid {
                            display: grid;
                            grid-template-columns: repeat(2, 1fr)!important;
                            justify-items: center;
                            min-height: 400px!important;
                            margin-top:200px;
                            margin-left: -22px!important;
                        }
                    }
                `}
            </style>

            <div className="u-align-center u-list u-list-1 boat-offers-container">
                <div className="u-repeater u-repeater-1 responsive-grid">
                    {offers.map((offer, index) => (
                        <div
                            key={index}
                            className="u-container-style u-list-item u-repeater-item boat-offer-item"
                        >
                            <div className={`u-container-layout u-similar-container ${offer.layoutClass}`}>
                                <div
                                    className={`u-border-3 u-border-custom-color-5 u-preserve-proportions u-shape u-shape-circle u-white ${offer.shapeClass} responsive-circle`}
                                    data-href={offer.href}
                                ></div>
                                <p className={`u-align-center u-custom-font u-font-montserrat u-text u-text-black ${offer.textClass} boat-offer-text`}>
                                    <a
                                        className={`u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-custom-color-5 u-text-hover-custom-color-10 ${offer.btnClass}`}
                                        href={offer.href}
                                    >
                                        <span style={{ fontWeight: 700 }}>{offer.title}</span><br />
                                        {offer.location}<br />
                                        {offer.type}<br />
                                        {offer.price}
                                    </a>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Ofertas;
